require('./files/description');
require('./files/personalized-services-search');
require('fabric/dist/fabric.min');
require('@simonwep/pickr/dist/pickr.min');
require('../library/fabric-functions');
require('./files/personalized-services-tool');
require('./files/modal-font');
require('./files/reviews');
require('./files/review-images-carousel');
require('./files/review-images');

require('../../sass/web/_description.scss');
require('../../sass/web/personalized_services_tool.scss');
require('@simonwep/pickr/dist/themes/classic.min.css');
require('../../css/web/tabs.css');
require('../../sass/web/review.scss');
require('../../css/web/reviews.css');
require('../../sass/web/reviews-images.scss');